import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'ip-profiles-summary',
  templateUrl: './ip-profiles-summary.component.html',
  styleUrls: ['./ip-profiles-summary.component.scss']
})
export class IpProfilesSummaryComponent implements OnInit {

  @Input() selection: any;

  constructor() {}

  ngOnInit(): void {
  }

}
